import { render, staticRenderFns } from "./IndustryMembers.vue?vue&type=template&id=4220a03d"
import script from "./IndustryMembers.vue?vue&type=script&lang=js"
export * from "./IndustryMembers.vue?vue&type=script&lang=js"
import style0 from "./IndustryMembers.vue?vue&type=style&index=0&id=4220a03d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports